import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { from as fromPromise, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { sponsorMessagesDecoder } from './decoder';
import { SponsorMessage } from './model';

@Injectable()
export class MessagingService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    getPendingMessages(): Observable<SponsorMessage[]> {
        return this.http
            .get<SponsorMessage[]>(`${this.environment.api}messaging/pending`)
            .pipe(concatMap(p => fromPromise(sponsorMessagesDecoder.decodeToPromise(p))));
    }

    acknowledgeMessage(id: number): Observable<unknown> {
        return this.http.post(`${this.environment.api}messaging/${id}/acknowledge`, null);
    }
}
